import { SharedModule } from 'app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccountsRoutingModule } from './accounts-routing.module';

import { ACCOUNT_DECLARATIONS } from './accounts.imports';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { PrefsGoalsComponent } from './prefs-goals/prefs-goals.component';
import { PrefsPipelineComponent } from './prefs-pipeline/prefs-pipeline.component';
import { ChangeTimezoneComponent } from './change-timezone/change-timezone.component';
import { UpdatePersonalInfoComponent } from './update-personal-info/update-personal-info.component';
import { BillingInformationComponent } from './billing-information/billing-information.component';
import { SetVariablesComponent } from './set-variables/set-variables.component';
import { BccManageComponent } from './bcc-manage/bcc-manage.component';
import { ViewRepresentativesComponent } from './view-representatives/view-representatives.component';
import {
  ManagerRoleRendererComponent,
} from './view-representatives/manager-role-renderer/manager-role-renderer.component';
import {
  ResetAccountPasswordComponent,
} from './view-representatives/reset-account-password/reset-account-password.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EditAccountComponent } from './list-accounts/edit-account/edit-account.component';
import {
  ChangeAccountPasswordComponent,
} from './list-accounts/change-account-password/change-account-password.component';
import { SetNotificationEmailComponent } from './list-accounts/set-notification-email/set-notification-email.component';
import { SetContactLimitComponent } from './list-accounts/set-contact-limit/set-contact-limit.component';
import { SetSendLimitComponent } from './list-accounts/set-send-limit/set-send-limit.component';
import { SuspendEmailsComponent } from './list-accounts/suspend-emails/suspend-emails.component';
import { InboxManagementComponent } from './inbox-management/inbox-management.component';
import { VsmAssignComponent } from '../list-accounts/vsm-control/vsm-assign/vsm-assign.component';
import { VsmInfoComponent } from '../list-accounts/vsm-info/vsm-info.component';
import { SetSmsDetailsComponent } from './set-sms-details/set-sms-details.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { IntegrationsComponent } from './integrations/integrations.component';
import { ApiKeysComponent } from './api-keys/api-keys.component';
import {
  ConfigureReportsDialogComponent,
} from './list-accounts/configure-reports-dialog/configure-reports-dialog.component';
import { ConfirmedAtComponent } from './list-accounts/confirmed-at/confirmed-at.component';
import {
  ManageSubscriptionDialogComponent,
} from './list-accounts/manage-subscription-dialog/manage-subscription-dialog.component';
import {
  MarkNotBillableDialogComponent,
} from './list-accounts/mark-not-billable-dialog/mark-not-billable-dialog.component';

@NgModule({
  declarations: [
    ...ACCOUNT_DECLARATIONS,
    ChangePasswordComponent,
    AccountSettingsComponent,
    PrefsGoalsComponent,
    PrefsPipelineComponent,
    ChangeTimezoneComponent,
    UpdatePersonalInfoComponent,
    BillingInformationComponent,
    SetVariablesComponent,
    BccManageComponent,
    ViewRepresentativesComponent,
    ManagerRoleRendererComponent,
    ResetAccountPasswordComponent,
    EditAccountComponent,
    ChangeAccountPasswordComponent,
    SetNotificationEmailComponent,
    SetContactLimitComponent,
    SetSendLimitComponent,
    SuspendEmailsComponent,
    InboxManagementComponent,
    VsmAssignComponent,
    VsmInfoComponent,
    SetSmsDetailsComponent,
    IntegrationsComponent,
    ApiKeysComponent,
    ConfigureReportsDialogComponent,
    ConfirmedAtComponent,
    ManageSubscriptionDialogComponent,
    MarkNotBillableDialogComponent,
    // ...UI_DECLARATIONS
    // ...AUTHENTICATED_DECLARATIONS
  ],
  imports: [
    // ...UI_IMPORTS,
    SharedModule,
    CommonModule,
    AccountsRoutingModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    NgxIntlTelInputModule,
  ],
  providers: [
    // ...UI_PROVIDERS
    { provide: TINYMCE_SCRIPT_SRC, useValue: '/tinymce/tinymce.min.js' },
  ],
})
export class AccountsModule {
}
